export const SHIPS_PATH = "picotitan";
export const LAST_SHIP_KEY = "lastPicoShip";
export const SHIPS_MEMBER_KEY = "picotitan";
